import styled from 'styled-components'

export const ActualContainer = styled.div`
  width: 100%;
  padding: 0px var(--size-large);

  @media (min-width: 1500px) {
    padding: 0px 5%;
  }

  @media (min-width: 2000px) {
    padding: 0px 12%;
  }

  @media (min-width: 2200px) {
    padding: 0px 15%;
  }
`
